import { Page } from '@ui/themed';
import type { PropsWithChildren } from 'react';
import { SetupBanner } from '../../onboarding';
import { ExploreCard } from '../components/explore-card';
import { OnboardingCard } from '../components/onboarding-card';
import { WhatIsSparkLayerCard } from '../components/what-is-sparklayer-card';

export function PreLaunchPage({ children }: PropsWithChildren) {
  return (
    <Page>
      {children}
      <SetupBanner />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-[1fr_1fr] md:gap-3">
        <ExploreCard />
        <OnboardingCard />
      </div>
      <WhatIsSparkLayerCard />
    </Page>
  );
}
